var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// server/lib/external-integration/constants.js
var require_constants = __commonJS({
  "server/lib/external-integration/constants.js"(exports, module) {
    var EXTERNAL_INTEGRATION_LABEL = "io.gladysassistant.external-integration";
    var MANIFEST_IMAGE_LABEL = "io.gladysassistant.manifest";
    var MANIFEST_FILE_NAME = "gladys-assistant-integration.json";
    var INTEGRATIONS_NETWORK_NAME = "gladys-integrations";
    var INTEGRATIONS_NETWORK_SUBNET = "172.30.0.0/24";
    var INTEGRATIONS_NETWORK_GATEWAY = "172.30.0.1";
    var PRIVATE_NETWORK_PREFIX = "gladys-int-";
    var SUB_CONTAINER_LABEL = "io.gladysassistant.container";
    var INTEGRATION_DATA_UID = 1e3;
    var INTEGRATION_DATA_GID = 1e3;
    var RECENTLY_PULLED_PROTECTION_MS = 60 * 60 * 1e3;
    var MAX_SUB_CONTAINERS = 5;
    var MAX_SUB_CONTAINER_VOLUMES = 5;
    var MAX_SUB_CONTAINER_PORTS = 3;
    var SUB_CONTAINER_NAME_REGEX = /^[a-z0-9-]{2,20}$/;
    var SUB_CONTAINER_PORT_NAME_REGEX = /^[a-z0-9_]{2,20}$/;
    var SUB_CONTAINER_MEMORY_MIN_MB = 32;
    var SUB_CONTAINER_MEMORY_MAX_MB = 4096;
    var SUB_CONTAINER_MEMORY_DEFAULT_MB = 256;
    var SUB_CONTAINER_CPU_MIN = 0.1;
    var SUB_CONTAINER_CPU_MAX = 2;
    var SUB_CONTAINER_CPU_DEFAULT = 0.5;
    var SUB_CONTAINER_SHM_MIN_MB = 64;
    var SUB_CONTAINER_SHM_MAX_MB = 512;
    var SUB_CONTAINER_SHM_DEFAULT_MB = 64;
    var SUB_CONTAINER_START_MODES = ["auto", "manual"];
    var HARDWARE_CLASSES = {
      "coral-usb": { path: "bus/usb" },
      "coral-pcie": { prefix: "apex_" },
      gpu: { path: "dri" },
      video: { prefix: "video" }
    };
    var SUB_CONTAINER_PORTS_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINER_PORTS";
    var SUB_CONTAINER_DESIRED_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINERS_DESIRED";
    var SUB_CONTAINER_ENV_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINERS_ENV";
    var INTEGRATION_JWT_SECRET_VARIABLE = "EXTERNAL_INTEGRATION_JWT_SECRET";
    var SELECTOR_PREFIX = "ext-";
    var DEV_SELECTOR_PREFIX = "ext-dev-";
    var SUPPORTED_MANIFEST_VERSION = 1;
    var STARTUP_TIMEOUT_MS = 60 * 1e3;
    var CHECK_HEALTH_INTERVAL_MS = 30 * 1e3;
    var HEARTBEAT_TIMEOUT_MS = 60 * 1e3;
    var STABLE_RUNNING_RESET_MS = 60 * 1e3;
    var MAX_FAILURE_COUNT = 5;
    var RESTART_BACKOFF_BASE_MS = 10 * 1e3;
    var RESTART_BACKOFF_MAX_MS = 15 * 60 * 1e3;
    var WEBSOCKET_PING_INTERVAL_MS = 20 * 1e3;
    var MAX_MISSED_PINGS = 2;
    var COMMAND_TIMEOUT_MS = 5 * 1e3;
    var MESSAGE_CONNECTION_WAIT_MS = 15 * 1e3;
    var MAX_ACTIONS = 10;
    var ACTION_MIN_TIMEOUT_SECONDS = 5;
    var ACTION_MAX_TIMEOUT_SECONDS = 120;
    var ACTION_DEFAULT_TIMEOUT_SECONDS = 30;
    var MAX_DISCOVERED_DEVICES = 2e3;
    var MAX_STATES_PER_REQUEST = 100;
    var MAX_STATES_PER_MINUTE = 300;
    var CONTACT_VARIABLE = "EXTERNAL_INTEGRATION_CONTACT";
    var CONTACT_PROFILE_VARIABLE = "EXTERNAL_INTEGRATION_CONTACT_PROFILE";
    var LINK_CODE_CACHE_PREFIX = "external-integration-link-code";
    var LINK_CODE_TTL_MS = 15 * 60 * 1e3;
    var LINK_CODE_LENGTH = 8;
    var MAX_MESSAGE_TEXT_LENGTH = 4096;
    var NETWORK_DISCOVERY_TYPES = ["udp-broadcast", "udp-active-broadcast", "mdns", "ssdp"];
    var MAX_NETWORK_DISCOVERY_ENTRIES = 5;
    var MAX_UDP_BROADCAST_PORTS = 5;
    var NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS = 1;
    var NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS = 30;
    var NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS = 10;
    var MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES = 512;
    var ACTIVE_BROADCAST_MIN_INTERVAL_MS = 10 * 1e3;
    var NETWORK_WAKE_MIN_INTERVAL_MS = 2 * 1e3;
    var MAX_CAMERA_IMAGES_PER_MINUTE = 12;
    var MAX_CAMERA_IMAGE_SIZE = 150 * 1024;
    var CAMERA_GET_IMAGE_TIMEOUT_MS = 15 * 1e3;
    var WEATHER_GET_TIMEOUT_MS = 15 * 1e3;
    var MAX_WEATHER_HOURS = 24;
    var MAX_WEATHER_DAYS = 8;
    var MAX_WEATHER_ALERTS = 10;
    var MAX_WEATHER_ALERT_EVENT_LENGTH = 100;
    var MAX_WEATHER_ALERT_DESCRIPTION_LENGTH = 5e3;
    var WEATHER_REFRESH_MIN_INTERVAL_MS = 60 * 1e3;
    var MAX_WEATHER_IMAGES = 3;
    var WEATHER_IMAGE_KEY_REGEX = /^[a-z0-9][a-z0-9-]{0,31}$/;
    var MAX_WEATHER_IMAGE_LABEL_LENGTH = 50;
    var MAX_WEATHER_IMAGE_BYTES = 500 * 1024;
    var WEATHER_IMAGE_CACHE_TTL_MS = 10 * 60 * 1e3;
    var WEATHER_IMAGE_CACHE_PREFIX = "weather-image";
    var WEATHER_CONDITIONS = [
      "clear",
      "partly-cloudy",
      "cloud",
      "fog",
      "drizzle",
      "rain",
      "pouring",
      "sleet",
      "hail",
      "snow",
      "thunderstorm",
      "wind",
      "night",
      "unknown"
    ];
    var WEATHER_ALERT_SEVERITIES = ["minor", "moderate", "severe", "extreme"];
    var WEATHER_ALERT_TYPES = [
      "wind",
      "rain",
      "flood",
      "thunderstorm",
      "snow",
      "heat",
      "cold",
      "avalanche",
      "coastal",
      "fog"
    ];
    var RESERVED_PARAM_PREFIX = "GLADYS_";
    var TRANSPORT_PARAM = "GLADYS_TRANSPORT";
    var DEVICE_TRANSPORTS = ["local", "cloud", "unreachable"];
    var MAX_TRANSPORTS_PER_REQUEST = 100;
    var TRANSPORT_DEGRADED_PARAM = "GLADYS_TRANSPORT_DEGRADED";
    var TRANSPORT_MESSAGE_PARAM = "GLADYS_TRANSPORT_MESSAGE";
    var MAX_TRANSPORT_MESSAGE_LENGTH = 200;
    var MANIFEST_TRANSPORTS = ["local", "cloud"];
    var PREFER_LOCAL_CONFIG_KEY = "GLADYS_PREFER_LOCAL";
    var ACCOUNT_FIELD_TYPES = ["oauth2", "account_link"];
    var MAX_MANIFEST_CATEGORIES = 3;
    var MAX_WEBHOOKS = 3;
    var WEBHOOK_MODES = ["fire_and_forget", "sync"];
    var WEBHOOK_DEFAULT_MODE = "fire_and_forget";
    var OPEN_API_KEY_CONFIG_KEY = "GLADYS_OPEN_API_KEY";
    var MAX_WEBHOOK_BODY_BYTES = 256 * 1024;
    var MAX_WEBHOOK_RESPONSE_BODY_BYTES = 64 * 1024;
    var WEBHOOK_RESPONSE_MIN_STATUS = 200;
    var WEBHOOK_RESPONSE_MAX_STATUS = 499;
    module.exports = {
      EXTERNAL_INTEGRATION_LABEL,
      MANIFEST_IMAGE_LABEL,
      MANIFEST_FILE_NAME,
      PRIVATE_NETWORK_PREFIX,
      SUB_CONTAINER_LABEL,
      INTEGRATION_DATA_UID,
      INTEGRATION_DATA_GID,
      RECENTLY_PULLED_PROTECTION_MS,
      MAX_SUB_CONTAINERS,
      MAX_SUB_CONTAINER_VOLUMES,
      MAX_SUB_CONTAINER_PORTS,
      SUB_CONTAINER_NAME_REGEX,
      SUB_CONTAINER_PORT_NAME_REGEX,
      SUB_CONTAINER_MEMORY_MIN_MB,
      SUB_CONTAINER_MEMORY_MAX_MB,
      SUB_CONTAINER_MEMORY_DEFAULT_MB,
      SUB_CONTAINER_CPU_MIN,
      SUB_CONTAINER_CPU_MAX,
      SUB_CONTAINER_CPU_DEFAULT,
      SUB_CONTAINER_SHM_MIN_MB,
      SUB_CONTAINER_SHM_MAX_MB,
      SUB_CONTAINER_SHM_DEFAULT_MB,
      SUB_CONTAINER_START_MODES,
      HARDWARE_CLASSES,
      SUB_CONTAINER_PORTS_VARIABLE,
      SUB_CONTAINER_DESIRED_VARIABLE,
      SUB_CONTAINER_ENV_VARIABLE,
      INTEGRATIONS_NETWORK_NAME,
      INTEGRATIONS_NETWORK_SUBNET,
      INTEGRATIONS_NETWORK_GATEWAY,
      INTEGRATION_JWT_SECRET_VARIABLE,
      SELECTOR_PREFIX,
      DEV_SELECTOR_PREFIX,
      SUPPORTED_MANIFEST_VERSION,
      STARTUP_TIMEOUT_MS,
      CHECK_HEALTH_INTERVAL_MS,
      HEARTBEAT_TIMEOUT_MS,
      STABLE_RUNNING_RESET_MS,
      MAX_FAILURE_COUNT,
      RESTART_BACKOFF_BASE_MS,
      RESTART_BACKOFF_MAX_MS,
      WEBSOCKET_PING_INTERVAL_MS,
      MAX_MISSED_PINGS,
      COMMAND_TIMEOUT_MS,
      MESSAGE_CONNECTION_WAIT_MS,
      MAX_ACTIONS,
      ACTION_MIN_TIMEOUT_SECONDS,
      ACTION_MAX_TIMEOUT_SECONDS,
      ACTION_DEFAULT_TIMEOUT_SECONDS,
      MAX_DISCOVERED_DEVICES,
      MAX_STATES_PER_REQUEST,
      MAX_STATES_PER_MINUTE,
      CONTACT_VARIABLE,
      CONTACT_PROFILE_VARIABLE,
      LINK_CODE_CACHE_PREFIX,
      LINK_CODE_TTL_MS,
      LINK_CODE_LENGTH,
      MAX_MESSAGE_TEXT_LENGTH,
      NETWORK_DISCOVERY_TYPES,
      MAX_NETWORK_DISCOVERY_ENTRIES,
      MAX_UDP_BROADCAST_PORTS,
      MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES,
      ACTIVE_BROADCAST_MIN_INTERVAL_MS,
      NETWORK_WAKE_MIN_INTERVAL_MS,
      NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS,
      NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS,
      NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS,
      MAX_CAMERA_IMAGES_PER_MINUTE,
      MAX_CAMERA_IMAGE_SIZE,
      CAMERA_GET_IMAGE_TIMEOUT_MS,
      WEATHER_GET_TIMEOUT_MS,
      MAX_WEATHER_HOURS,
      MAX_WEATHER_DAYS,
      MAX_WEATHER_ALERTS,
      MAX_WEATHER_ALERT_EVENT_LENGTH,
      MAX_WEATHER_ALERT_DESCRIPTION_LENGTH,
      WEATHER_CONDITIONS,
      WEATHER_ALERT_SEVERITIES,
      WEATHER_ALERT_TYPES,
      WEATHER_REFRESH_MIN_INTERVAL_MS,
      MAX_WEATHER_IMAGES,
      WEATHER_IMAGE_KEY_REGEX,
      MAX_WEATHER_IMAGE_LABEL_LENGTH,
      MAX_WEATHER_IMAGE_BYTES,
      WEATHER_IMAGE_CACHE_TTL_MS,
      WEATHER_IMAGE_CACHE_PREFIX,
      RESERVED_PARAM_PREFIX,
      TRANSPORT_PARAM,
      DEVICE_TRANSPORTS,
      MAX_TRANSPORTS_PER_REQUEST,
      TRANSPORT_DEGRADED_PARAM,
      TRANSPORT_MESSAGE_PARAM,
      MAX_TRANSPORT_MESSAGE_LENGTH,
      MANIFEST_TRANSPORTS,
      PREFER_LOCAL_CONFIG_KEY,
      ACCOUNT_FIELD_TYPES,
      MAX_MANIFEST_CATEGORIES,
      MAX_WEBHOOKS,
      WEBHOOK_MODES,
      WEBHOOK_DEFAULT_MODE,
      OPEN_API_KEY_CONFIG_KEY,
      MAX_WEBHOOK_BODY_BYTES,
      MAX_WEBHOOK_RESPONSE_BODY_BYTES,
      WEBHOOK_RESPONSE_MIN_STATUS,
      WEBHOOK_RESPONSE_MAX_STATUS
    };
  }
});
const __cjsModule = require_constants();
export default __cjsModule;
export const EXTERNAL_INTEGRATION_LABEL = __cjsModule.EXTERNAL_INTEGRATION_LABEL;
export const MANIFEST_IMAGE_LABEL = __cjsModule.MANIFEST_IMAGE_LABEL;
export const MANIFEST_FILE_NAME = __cjsModule.MANIFEST_FILE_NAME;
export const PRIVATE_NETWORK_PREFIX = __cjsModule.PRIVATE_NETWORK_PREFIX;
export const SUB_CONTAINER_LABEL = __cjsModule.SUB_CONTAINER_LABEL;
export const INTEGRATION_DATA_UID = __cjsModule.INTEGRATION_DATA_UID;
export const INTEGRATION_DATA_GID = __cjsModule.INTEGRATION_DATA_GID;
export const RECENTLY_PULLED_PROTECTION_MS = __cjsModule.RECENTLY_PULLED_PROTECTION_MS;
export const MAX_SUB_CONTAINERS = __cjsModule.MAX_SUB_CONTAINERS;
export const MAX_SUB_CONTAINER_VOLUMES = __cjsModule.MAX_SUB_CONTAINER_VOLUMES;
export const MAX_SUB_CONTAINER_PORTS = __cjsModule.MAX_SUB_CONTAINER_PORTS;
export const SUB_CONTAINER_NAME_REGEX = __cjsModule.SUB_CONTAINER_NAME_REGEX;
export const SUB_CONTAINER_PORT_NAME_REGEX = __cjsModule.SUB_CONTAINER_PORT_NAME_REGEX;
export const SUB_CONTAINER_MEMORY_MIN_MB = __cjsModule.SUB_CONTAINER_MEMORY_MIN_MB;
export const SUB_CONTAINER_MEMORY_MAX_MB = __cjsModule.SUB_CONTAINER_MEMORY_MAX_MB;
export const SUB_CONTAINER_MEMORY_DEFAULT_MB = __cjsModule.SUB_CONTAINER_MEMORY_DEFAULT_MB;
export const SUB_CONTAINER_CPU_MIN = __cjsModule.SUB_CONTAINER_CPU_MIN;
export const SUB_CONTAINER_CPU_MAX = __cjsModule.SUB_CONTAINER_CPU_MAX;
export const SUB_CONTAINER_CPU_DEFAULT = __cjsModule.SUB_CONTAINER_CPU_DEFAULT;
export const SUB_CONTAINER_SHM_MIN_MB = __cjsModule.SUB_CONTAINER_SHM_MIN_MB;
export const SUB_CONTAINER_SHM_MAX_MB = __cjsModule.SUB_CONTAINER_SHM_MAX_MB;
export const SUB_CONTAINER_SHM_DEFAULT_MB = __cjsModule.SUB_CONTAINER_SHM_DEFAULT_MB;
export const SUB_CONTAINER_START_MODES = __cjsModule.SUB_CONTAINER_START_MODES;
export const HARDWARE_CLASSES = __cjsModule.HARDWARE_CLASSES;
export const SUB_CONTAINER_PORTS_VARIABLE = __cjsModule.SUB_CONTAINER_PORTS_VARIABLE;
export const SUB_CONTAINER_DESIRED_VARIABLE = __cjsModule.SUB_CONTAINER_DESIRED_VARIABLE;
export const SUB_CONTAINER_ENV_VARIABLE = __cjsModule.SUB_CONTAINER_ENV_VARIABLE;
export const INTEGRATIONS_NETWORK_NAME = __cjsModule.INTEGRATIONS_NETWORK_NAME;
export const INTEGRATIONS_NETWORK_SUBNET = __cjsModule.INTEGRATIONS_NETWORK_SUBNET;
export const INTEGRATIONS_NETWORK_GATEWAY = __cjsModule.INTEGRATIONS_NETWORK_GATEWAY;
export const INTEGRATION_JWT_SECRET_VARIABLE = __cjsModule.INTEGRATION_JWT_SECRET_VARIABLE;
export const SELECTOR_PREFIX = __cjsModule.SELECTOR_PREFIX;
export const DEV_SELECTOR_PREFIX = __cjsModule.DEV_SELECTOR_PREFIX;
export const SUPPORTED_MANIFEST_VERSION = __cjsModule.SUPPORTED_MANIFEST_VERSION;
export const STARTUP_TIMEOUT_MS = __cjsModule.STARTUP_TIMEOUT_MS;
export const CHECK_HEALTH_INTERVAL_MS = __cjsModule.CHECK_HEALTH_INTERVAL_MS;
export const HEARTBEAT_TIMEOUT_MS = __cjsModule.HEARTBEAT_TIMEOUT_MS;
export const STABLE_RUNNING_RESET_MS = __cjsModule.STABLE_RUNNING_RESET_MS;
export const MAX_FAILURE_COUNT = __cjsModule.MAX_FAILURE_COUNT;
export const RESTART_BACKOFF_BASE_MS = __cjsModule.RESTART_BACKOFF_BASE_MS;
export const RESTART_BACKOFF_MAX_MS = __cjsModule.RESTART_BACKOFF_MAX_MS;
export const WEBSOCKET_PING_INTERVAL_MS = __cjsModule.WEBSOCKET_PING_INTERVAL_MS;
export const MAX_MISSED_PINGS = __cjsModule.MAX_MISSED_PINGS;
export const COMMAND_TIMEOUT_MS = __cjsModule.COMMAND_TIMEOUT_MS;
export const MESSAGE_CONNECTION_WAIT_MS = __cjsModule.MESSAGE_CONNECTION_WAIT_MS;
export const MAX_ACTIONS = __cjsModule.MAX_ACTIONS;
export const ACTION_MIN_TIMEOUT_SECONDS = __cjsModule.ACTION_MIN_TIMEOUT_SECONDS;
export const ACTION_MAX_TIMEOUT_SECONDS = __cjsModule.ACTION_MAX_TIMEOUT_SECONDS;
export const ACTION_DEFAULT_TIMEOUT_SECONDS = __cjsModule.ACTION_DEFAULT_TIMEOUT_SECONDS;
export const MAX_DISCOVERED_DEVICES = __cjsModule.MAX_DISCOVERED_DEVICES;
export const MAX_STATES_PER_REQUEST = __cjsModule.MAX_STATES_PER_REQUEST;
export const MAX_STATES_PER_MINUTE = __cjsModule.MAX_STATES_PER_MINUTE;
export const CONTACT_VARIABLE = __cjsModule.CONTACT_VARIABLE;
export const CONTACT_PROFILE_VARIABLE = __cjsModule.CONTACT_PROFILE_VARIABLE;
export const LINK_CODE_CACHE_PREFIX = __cjsModule.LINK_CODE_CACHE_PREFIX;
export const LINK_CODE_TTL_MS = __cjsModule.LINK_CODE_TTL_MS;
export const LINK_CODE_LENGTH = __cjsModule.LINK_CODE_LENGTH;
export const MAX_MESSAGE_TEXT_LENGTH = __cjsModule.MAX_MESSAGE_TEXT_LENGTH;
export const NETWORK_DISCOVERY_TYPES = __cjsModule.NETWORK_DISCOVERY_TYPES;
export const MAX_NETWORK_DISCOVERY_ENTRIES = __cjsModule.MAX_NETWORK_DISCOVERY_ENTRIES;
export const MAX_UDP_BROADCAST_PORTS = __cjsModule.MAX_UDP_BROADCAST_PORTS;
export const MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES = __cjsModule.MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES;
export const ACTIVE_BROADCAST_MIN_INTERVAL_MS = __cjsModule.ACTIVE_BROADCAST_MIN_INTERVAL_MS;
export const NETWORK_WAKE_MIN_INTERVAL_MS = __cjsModule.NETWORK_WAKE_MIN_INTERVAL_MS;
export const NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS;
export const NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS;
export const NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS;
export const MAX_CAMERA_IMAGES_PER_MINUTE = __cjsModule.MAX_CAMERA_IMAGES_PER_MINUTE;
export const MAX_CAMERA_IMAGE_SIZE = __cjsModule.MAX_CAMERA_IMAGE_SIZE;
export const CAMERA_GET_IMAGE_TIMEOUT_MS = __cjsModule.CAMERA_GET_IMAGE_TIMEOUT_MS;
export const WEATHER_GET_TIMEOUT_MS = __cjsModule.WEATHER_GET_TIMEOUT_MS;
export const MAX_WEATHER_HOURS = __cjsModule.MAX_WEATHER_HOURS;
export const MAX_WEATHER_DAYS = __cjsModule.MAX_WEATHER_DAYS;
export const MAX_WEATHER_ALERTS = __cjsModule.MAX_WEATHER_ALERTS;
export const MAX_WEATHER_ALERT_EVENT_LENGTH = __cjsModule.MAX_WEATHER_ALERT_EVENT_LENGTH;
export const MAX_WEATHER_ALERT_DESCRIPTION_LENGTH = __cjsModule.MAX_WEATHER_ALERT_DESCRIPTION_LENGTH;
export const WEATHER_CONDITIONS = __cjsModule.WEATHER_CONDITIONS;
export const WEATHER_ALERT_SEVERITIES = __cjsModule.WEATHER_ALERT_SEVERITIES;
export const WEATHER_ALERT_TYPES = __cjsModule.WEATHER_ALERT_TYPES;
export const WEATHER_REFRESH_MIN_INTERVAL_MS = __cjsModule.WEATHER_REFRESH_MIN_INTERVAL_MS;
export const MAX_WEATHER_IMAGES = __cjsModule.MAX_WEATHER_IMAGES;
export const WEATHER_IMAGE_KEY_REGEX = __cjsModule.WEATHER_IMAGE_KEY_REGEX;
export const MAX_WEATHER_IMAGE_LABEL_LENGTH = __cjsModule.MAX_WEATHER_IMAGE_LABEL_LENGTH;
export const MAX_WEATHER_IMAGE_BYTES = __cjsModule.MAX_WEATHER_IMAGE_BYTES;
export const WEATHER_IMAGE_CACHE_TTL_MS = __cjsModule.WEATHER_IMAGE_CACHE_TTL_MS;
export const WEATHER_IMAGE_CACHE_PREFIX = __cjsModule.WEATHER_IMAGE_CACHE_PREFIX;
export const RESERVED_PARAM_PREFIX = __cjsModule.RESERVED_PARAM_PREFIX;
export const TRANSPORT_PARAM = __cjsModule.TRANSPORT_PARAM;
export const DEVICE_TRANSPORTS = __cjsModule.DEVICE_TRANSPORTS;
export const MAX_TRANSPORTS_PER_REQUEST = __cjsModule.MAX_TRANSPORTS_PER_REQUEST;
export const TRANSPORT_DEGRADED_PARAM = __cjsModule.TRANSPORT_DEGRADED_PARAM;
export const TRANSPORT_MESSAGE_PARAM = __cjsModule.TRANSPORT_MESSAGE_PARAM;
export const MAX_TRANSPORT_MESSAGE_LENGTH = __cjsModule.MAX_TRANSPORT_MESSAGE_LENGTH;
export const MANIFEST_TRANSPORTS = __cjsModule.MANIFEST_TRANSPORTS;
export const PREFER_LOCAL_CONFIG_KEY = __cjsModule.PREFER_LOCAL_CONFIG_KEY;
export const ACCOUNT_FIELD_TYPES = __cjsModule.ACCOUNT_FIELD_TYPES;
export const MAX_MANIFEST_CATEGORIES = __cjsModule.MAX_MANIFEST_CATEGORIES;
export const MAX_WEBHOOKS = __cjsModule.MAX_WEBHOOKS;
export const WEBHOOK_MODES = __cjsModule.WEBHOOK_MODES;
export const WEBHOOK_DEFAULT_MODE = __cjsModule.WEBHOOK_DEFAULT_MODE;
export const OPEN_API_KEY_CONFIG_KEY = __cjsModule.OPEN_API_KEY_CONFIG_KEY;
export const MAX_WEBHOOK_BODY_BYTES = __cjsModule.MAX_WEBHOOK_BODY_BYTES;
export const MAX_WEBHOOK_RESPONSE_BODY_BYTES = __cjsModule.MAX_WEBHOOK_RESPONSE_BODY_BYTES;
export const WEBHOOK_RESPONSE_MIN_STATUS = __cjsModule.WEBHOOK_RESPONSE_MIN_STATUS;
export const WEBHOOK_RESPONSE_MAX_STATUS = __cjsModule.WEBHOOK_RESPONSE_MAX_STATUS;
